// extracted by mini-css-extract-plugin
export default {"CounterCard":"common_CounterCard__rkbXr","cardCstm":"common_cardCstm__zWpYh","cstmPagination":"common_cstmPagination__IAHM9"};